import { TextInput } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { IconSearch } from '@tabler/icons-react';
import classNames from 'classnames';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type DebouncedSearchInputProps = {
  onDebouncedChange: (value: string) => void;
  debounceMs?: number;
  className?: string;
  wrapClassName?: string;
};

export const DebouncedSearchInput = memo(function DebouncedSearchInput({
  onDebouncedChange,
  debounceMs = 400,
  className,
  wrapClassName,
}: DebouncedSearchInputProps) {
  const { t } = useTranslation(['common'], { useSuspense: false });
  const [value, setValue] = useState('');
  const [debounced] = useDebouncedValue(value, debounceMs);

  useEffect(() => {
    onDebouncedChange(debounced);
  }, [debounced, onDebouncedChange]);

  const input = (
    <TextInput
      className={className}
      leftSection={<IconSearch size={18} stroke={1.75} />}
      placeholder={t('common:search_filter')}
      radius="md"
      size="md"
      value={value}
      onChange={(event) => setValue(event.currentTarget.value)}
    />
  );

  if (wrapClassName) {
    return <div className={classNames(wrapClassName)}>{input}</div>;
  }

  return input;
});
